import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Theme store - manages dark/light mode with localStorage persistence
 */
export const useThemeStore = create(
    persist(
        (set) => ({
            isDark: false,

            // Toggle between dark and light mode
            toggleTheme: () =>
                set((state) => {
                    const newIsDark = !state.isDark;
                    // Update document class
                    if (newIsDark) {
                        document.documentElement.classList.add("dark");
                    } else {
                        document.documentElement.classList.remove("dark");
                    }
                    return { isDark: newIsDark };
                }),

            // Set theme directly
            setTheme: (isDark) =>
                set(() => {
                    if (isDark) {
                        document.documentElement.classList.add("dark");
                    } else {
                        document.documentElement.classList.remove("dark");
                    }
                    return { isDark };
                }),
        }),
        {
            name: "theme-storage",
            // Initialize theme class on hydration
            onRehydrateStorage: () => (state) => {
                if (state?.isDark) {
                    document.documentElement.classList.add("dark");
                } else {
                    document.documentElement.classList.remove("dark");
                }
            },
        }
    )
);
